import PageTemplate from "../Components/PageTemplate/PageTemplate";

export default function Error404NotFound() {
    return <PageTemplate sidebar={"normal"}>
        Error 404
    </PageTemplate>;
}